<script setup>
import { onBeforeMount, onMounted, onUnmounted, onUpdated} from "vue";
import InvoiceTransactionsRow from "../components/InvoiceTransactionsRow.vue";
import setTooltip from "../assets/js/tooltip.js";
import validSession from "../assets/js/valid-session.js";
import { useStore } from "vuex";
import axios from "axios";
import { toast } from 'vue3-toastify';
import 'animate.css';
import { useRoute } from "vue-router";
import SkeletonLoad from "../components/SkeletonLoad.vue";
import emitter from "../assets/js/eventBus.js";
import startResize from "../assets/js/resize.js";
import { computed } from "vue";

let meses = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ];

const store = useStore();
const route = useRoute();

const darkMode = computed(() => store.state.darkMode);

onBeforeMount(() => {

    validSession.isLogged();

    store.state.transaction_value = {
        value: 0
    }

    store.state.invoice_load = true;

    store.state.accounts = [];
    store.state.cards = [];
    store.state.transations = [];
    store.state.categoriesExpense = {};
    store.state.categoriesRevenue = {};
    store.state.loadingTransactions = true;
    store.state.savingTransaction = false;
    store.state.modalColor = '';

    store.state.selectedYear = new Date().getFullYear();
    store.state.selectedMonth = {
        index: new Date().getMonth(),
        number: new Date().getMonth() + 1,
        display: meses[new Date().getMonth()]
    };

    store.state.validation = {
        descHasError: false,
        descMessageError: '',
        accountError: false,
        accountMessageError: '',
        categorryError: false,
        categoryMessageError: ''
    };

    let day = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();

    store.state.current_date = year+ '-' + (month < 10 ? '0'+month : month) + '-' + (day < 10 ? '0'+ day : day);

    store.state.transation = {
        type: '',
        description: '',
        amount: 0,
        date: store.state.current_date,
        account: '',
        account_name: '',
        account_destiny: '',
        account_destiny_name: '',
        category: '',
        category_name: '',
        category_icon: '',
        category_color: '',
        recurrence_checked: false,
        recurrence: '',
        recurrence_period: 'monthly',
        initial_installment: 1,
        current_installment: 1,
        end_installment: 1,
        payed: false,
        id: '',
        transaction_id: '',
        invoice_id: '',
        card_id: '',
        howUpdate: '',
        amount_paid: 0,
        ammount_unpaid: 0,
        observation: ''
    }

    store.state.card_details = {
        icon: '',
        name: '',
        id: ''
    };

    store.state.invoice_details = {
        before_amount: parseFloat(0),
        amount: parseFloat(0),
        close_date: '',
        due_date: '',
        id: '',
        order: 0,
        status: ''
    };

    store.state.suggestions = [];

    store.state.invoice_id = route.params.id ? route.params.id : 0;

    getInvoice(store.state.invoice_id);

    getCards();
    getAccounts();
    getExpenseCategories();
    getRevenueCategories();

})

const reload_data = () => {
    getInvoice(store.state.invoice_id);
};

const get_data = () => {

    emitter.emit('receive-data', { data: store.state.card_details.id+'-card' });

};

onMounted(() => {

    emitter.on('load-data', reload_data);
    emitter.on('get-data', get_data);

  setTooltip();
});

onUpdated(() => {
    if(!store.state.loadingTransactions){
        startResize(181);
    }
})

onUnmounted(() => {
    emitter.off('load-data', reload_data);
    emitter.off('get-data', get_data);
});

const getInvoice = async (id) => {

    axios.get('invoices/show/'+id)
    .then(res => {
        
        if(res.status == 200){

            store.state.card_details = {
                icon: res.data.card_icon,
                name: res.data.card_name,
                id: res.data.card_id
            };

            store.state.invoice_details = {
                before_amount: parseFloat(res.data.before_amount),
                current_amount: parseFloat(res.data.current_amount),
                payed_amount: parseFloat(res.data.payed_amount),
                close_date: res.data.close_date,
                due_date: res.data.due_date,
                id: res.data.id,
                order: res.data.order,
                status: res.data.status,
                payment: res.data.payment
            };

            store.state.selectedYear = new Date(res.data.due_date).getFullYear();
            store.state.selectedMonth = {
                index: new Date(res.data.due_date+'T01:00:00').getMonth(),
                number: new Date(res.data.due_date+'T01:00:00').getMonth() + 1,
                display: meses[new Date(res.data.due_date+'T01:00:00').getMonth()]
            };

            getTransaction(res.data.id);

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getInvoiceByOrder = async (order) => {

    axios.get('invoices/show-by-order?card='+store.state.card_details.id+'&order='+order)
    .then(res => {
        
        if(res.status == 200){

            store.state.card_details = {
                icon: res.data.card_icon,
                name: res.data.card_name,
                id: res.data.card_id
            };

            store.state.invoice_details = {
                before_amount: parseFloat(res.data.before_amount),
                current_amount: parseFloat(res.data.current_amount),
                payed_amount: parseFloat(res.data.payed_amount),
                close_date: res.data.close_date,
                due_date: res.data.due_date,
                id: res.data.id,
                order: res.data.order,
                status: res.data.status,
                payment: res.data.payment
            };

            store.state.selectedYear = new Date(res.data.due_date+'T01:00:00').getFullYear();
            store.state.selectedMonth = {
                index: new Date(res.data.due_date+'T01:00:00').getMonth(),
                number: new Date(res.data.due_date+'T01:00:00').getMonth() + 1,
                display: meses[new Date(res.data.due_date+'T01:00:00').getMonth()]
            };

            getTransaction(res.data.id);

            let nextURL = window.location.origin + '/fatura/'+res.data.id;
            let nextTitle = 'Agive Finanças';
            let nextState = { additionalInformation: 'Updated the URL with JS' };

            window.history.pushState(nextState, nextTitle, nextURL);
            window.history.replaceState(nextState, nextTitle, nextURL);

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getTransaction = async (invoice) => {

    store.state.loadingTransactions = true;

    axios.get('transactions?invoice='+invoice)
    .then(res => {
        
        if(res.status == 200){

            store.state.transations = res.data;
            store.state.loadingTransactions = false;
            store.state.invoice_load = false;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getAccounts = async () => {

    axios.get('accounts')
    .then(res => {
        
        if(res.status == 200){

            store.state.accounts = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getCards = async () => {

    axios.get('credit-cards')
    .then(res => {
        
        if(res.status == 200){

            store.state.cards = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getExpenseCategories = async () => {

    axios.get('categories?type=despesa')
    .then(res => {
        
        if(res.status == 200){

            store.state.categoriesExpense = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getRevenueCategories = async () => {

    axios.get('categories?type=receita')
    .then(res => {

    if(res.status == 200){

        store.state.categoriesRevenue = res.data;

    }

    })
    .catch(err => {
        console.error(err); 
    })

}

const clearFields = () => {

    store.state.transaction_value.value = 0;

    store.state.transation = {
        type: '',
        description: '',
        amount: 0,
        date: store.state.current_date,
        account: '',
        account_name: '',
        account_destiny: '',
        account_destiny_name: '',
        category: '',
        category_name: '',
        category_icon: '',
        category_color: '',
        recurrence_checked: false,
        recurrence: '',
        recurrence_period: 'monthly',
        initial_installment: 1,
        current_installment: 1,
        end_installment: 1,
        payed: false,
        id: '',
        transaction_id: '',
        invoice_id: '',
        card_id: '',
        howUpdate: '',
        amount_paid: 0,
        ammount_unpaid: 0,
        observation: ''
    }

    store.state.suggestions = [];
}


const editTrasaction = (data) => {

    emitter.emit('edit-transaction', { data });
    emitter.emit('set-type', { data: data.type }, true);

}

const payTransation = (id, status) => {

    store.state.invoice_load = true;

    let url = '/transactions/pay/'+id;

    let data = new FormData();

    data.append('status', status == 'Paid' ? 'Unpaid' : 'Paid');

    axios.post(url, data)
    .then(res => {
        
        if(!res.data.error){

            toast('Lançamento atualizado com sucesso!', {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            getTransaction();
            clearFields();

        }

    })
    .catch(err => {
        console.error(err); 
    })

}

const slideDate = (direction) => {

    store.state.invoice_load = true;

    if(direction == 'prev'){

        let prev_month = store.state.selectedMonth.index > 0 ? store.state.selectedMonth.index - 1 : 11;
        let prev_year = store.state.selectedMonth.index > 0 ? store.state.selectedYear : store.state.selectedYear - 1;
        
        store.state.selectedYear = prev_year;
        store.state.selectedMonth = {
            index: prev_month,
            number: prev_month + 1,
            display: meses[prev_month]
        };

        getInvoiceByOrder(parseInt(store.state.invoice_details.order) - 1);

    }
    else if(direction == 'next'){

        let next_month = store.state.selectedMonth.index < 11 ? store.state.selectedMonth.index + 1 : 0;
        let next_year = store.state.selectedMonth.index < 11 ? store.state.selectedYear : store.state.selectedYear + 1;

        store.state.selectedYear = next_year;
        store.state.selectedMonth = {
            index: next_month,
            number: next_month + 1,
            display: meses[next_month]
        };

        getInvoiceByOrder(parseInt(store.state.invoice_details.order) + 1);

    }

}

const formatMoney = (v) => {
    let total = parseFloat(v);

    return total.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
        });
}

const formatDate = (d) => {
    
    let date = new Date(d);
    
    return date.toLocaleDateString('pt-BR', {timeZone: 'UTC'});

}

const rotate = (id) => {

    let element = document.getElementById(id);

    element.classList.toggle('fa-rotate-90');

}

const valid_status = (status, type) => {

        if(status == 'Open'){

            if(type == 'class'){
                return 'secondary';
            }
            else if(type == 'title'){
                return 'Em aberto';
            }

        }
        else if(status == 'Closed'){

            if(type == 'class'){
                return 'warning';
            }
            else if(type == 'title'){
                return 'Fechada';
            }

        }
        else if(status == 'Paid'){

            if(type == 'class'){
                return 'success';
            }
            else if(type == 'title'){
                return 'Paga';
            }
            
        }
        else if(status == 'Late'){

            if(type == 'class'){
                return 'error';
            }else if(type == 'title'){
                return 'Em Atraso';
            }          
        }
        else if(status == 'Current'){

            if(type == 'class'){
                return 'info';
            }else if(type == 'title'){
                return 'Atual';
            }          
        }

    }

</script>
<template>

    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="row align-items-center shadow sticky-top header-transaction pt-lg-3 pb-lg-3" :class="darkMode ? 'darkmode' : ''">
                    <div class="col-7 col-lg-4 order-2 order-lg-1 mt-n2 mt-xl-0">
                        <div class="row align-items-center">
                            <div class="col-3 col-xl-2">
                                <SkeletonLoad
                                    :width='"50px"'
                                    :height="'50px'"
                                    :class="'rounded'"
                                    v-if="store.state.invoice_load"
                                />
                                <img v-else :src="store.state.card_details.icon" alt="" width="40" class="rounded-5 mt-n3 mt-xl-0">
                            </div>
                            <div class="col-6">
                                <SkeletonLoad
                                    :width='"120px"'
                                    :height="'30px'"
                                    :class="'ms-1 ms-lg-0'"
                                    v-if="store.state.invoice_load"
                                />
                                <h6 class="ms-0 mt-xl-1" v-else>{{ store.state.card_details.name }}</h6>
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 text-center order-1 order-lg-2 mt-3 mb-2 mt-lg-0 mb-lg-0">
                        <div class="row">
                            <div class="col-2 col-lg-3">
                                <a class="cursor-pointer" @click="slideDate('prev')">
                                    <i class="fal fa-chevron-left me-0 me-lg-5"></i>
                                </a>
                            </div>
                            <div class="col-8 col-lg-6 mx-auto">
                                <span>
                                    {{ store.state.selectedMonth.display }} {{ store.state.selectedYear }}
                                </span>
                            </div>
                            <div class="col-2 col-lg-3">
                                <a class="cursor-pointer" @click="slideDate('next')">
                                    <i class="fal fa-chevron-right ms-0 ms-lg-5"></i>
                                </a>
                            </div>
                        </div>
                        
                        <hr class="d-lg-none">
                    </div>
                    <div class="col-5 col-lg-4 order-3 text-end">
                        
                      <p class="mt-n2 mt-xl-2"><b>{{ store.state.transations.length }} Lançamentos</b></p>   
                        
                    </div>
                </div>
                <div id="transactionList" class="row overflow-auto shadow" :class="!darkMode ? 'bg-white' : 'bg-222222'">

                    <div class="col-12 text-center mt-4 mb-4" v-if="store.state.loadingTransactions">
                        <div class="row">

                            <div class="col-2 col-lg-1 ms-3 text-center">
                                <SkeletonLoad
                                    :width='"50px"'
                                    :height="'50px'"
                                    :class="'rounded-5'"
                                />
                            </div>
                            <div class="col-6 col-lg-8">
                                <div class="row align-items-center">
                                    <div class="col-12 col-lg-6">
                                        <SkeletonLoad
                                            :width="'90px'"
                                            :height="'20px'"
                                        />
                                        <SkeletonLoad
                                            :width="'90px'"
                                            :height="'20px'"
                                            :class="'mt-2'"
                                        />
                                    </div>
                                    <div class="col-12 col-lg-3 text-lg-center d-none d-lg-block">
                                        <SkeletonLoad
                                            :width="'90px'"
                                            :height="'20px'"
                                        />
                                    </div>
                                    
                                </div>
                            </div>

                            <div class="col-3 col-lg-2 text-end">
                                
                                <div class="col-12 col-lg-3 text-lg-center mt-3">
                                    <SkeletonLoad
                                        :width="'90px'"
                                        :height="'20px'"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-12 text-center mt-4" v-if="store.state.transations.length == 0 && !store.state.loadingTransactions">
                        <p>Nenhum lançamento cadastrado.</p>
                    </div>

                    <div class="col-12 trasaction-list" v-if="!store.state.loadingTransactions">

                        <InvoiceTransactionsRow 
                            v-for="(transation, index) in store.state.transations" :key="index"
                            :transaction = transation
                            @edit="editTrasaction"
                            @pay="payTransation"
                        />

                    </div>

                </div>
                <div class="row footer-transaction shadow" :class="darkMode ? 'darkmode' : ''">
                    <div class="col-12 mt-3">
                        <div class="row align-items-center">
                            <div class="col-6 col-lg-8 text-end">
                                <p class="balance-text">
                                    Valor da fatura
                                    <br>
                                    Vencimento
                                    <br>
                                    Situação
                                </p>
                            </div>
                            <div class="col-4 col-lg-2 text-end">
                                <SkeletonLoad
                                    v-if="store.state.loading_balance"
                                    :width="'90px'"
                                    :height="'20px'"
                                    :class="'mt-n4 mb-1 float-end'"
                                />
                                <SkeletonLoad
                                    v-if="store.state.loading_balance"
                                    :width="'90px'"
                                    :height="'20px'"
                                    :class="'float-end'"
                                />
                                <p v-if="!store.state.loading_balance" class="balance-text">
                                    <b>{{ formatMoney((store.state.invoice_details.current_amount + store.state.invoice_details.before_amount)) }}</b>
                                    <br>
                                    {{ formatDate(store.state.invoice_details.due_date) }}
                                    <br>
                                    <span class="badge badge-sm mb-1 ms-2 mt-n3" :class="'bg-'+valid_status(store.state.invoice_details.status, 'class')"> {{valid_status(store.state.invoice_details.status, 'title')}}</span>
                                </p>
                            </div>
                            <div class="col-2">
                                <a 
                                    data-bs-toggle="collapse" 
                                    href="#collapseBalance" 
                                    role="button" 
                                    aria-expanded="false" 
                                    aria-controls="collapseBalance"
                                    @click="rotate('balance_chevron')"
                                >
                                    <i id="balance_chevron" class="fal fa-chevron-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="row collapse" id="collapseBalance">

                            <div class="col-6 col-lg-8 text-end">
                                <p class="balance-text">
                                    Saldo anterior
                                    <br>
                                    Fatura do mês
                                </p>
                            </div>
                            <div class="col-4 col-lg-2 text-end">
                                <p class="balance-text">
                                    <span class="text-danger">{{ formatMoney(store.state.invoice_details.before_amount) }}</span>
                                    <br>
                                    <span class="text-danger">{{ formatMoney((store.state.invoice_details.current_amount + store.state.invoice_details.before_amount)) }}</span>
                                </p>
                            </div>
                            <div class="col-2"></div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style>

.trasation-list-add-button{
    font-size: 18px;
}

.btn-gray{
    background-color: #67748e !important;
    color: #fff !important;
}

.modal-body.darkmode{
    background-color: #3d3d3d !important;
}

.trasaction-card-list{
    max-height: 75vh;
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
}

.auto-complete-list{
    list-style-type: none;
    max-height: 120px;
    overflow-y: auto;
    overflow-x: hidden;
}

.auto-complete-list.darkmode{
    background-color: #3d3d3d !important;
}

@media (max-height: 700px) and (max-width: 575.98px){

    .trasaction-card-list{
        max-height: 44vh;
    }

}

@media (min-height: 701px) and (max-height: 750px) and (max-width: 575.98px){

    .trasaction-card-list{
        max-height: 49vh;
    }

}

@media (min-height: 751px) and (max-height: 900px) and (max-width: 575.98px){

    .trasaction-card-list{
        max-height: 55vh;
    }

}

@media (min-height: 751px) and (max-height: 900px) and (min-width: 900px) and (max-width: 1050px){

    .trasaction-card-list{
        max-height: 66vh;
    }

}

@media (min-height: 901px) and (max-height: 920px) and (max-width: 575.98px){

    .trasaction-card-list{
        max-height: 58vh;
    }

}

@media (min-height: 921px) and (max-height: 950px) and (max-width: 575.98px){

    .trasaction-card-list{
        max-height: 59vh;
    }

}

@media (min-height: 951px) and (max-height: 1050px) and (max-width: 780px){

    .trasaction-card-list{
        max-height: 62vh;
    }

}

@media (max-width: 575.98px) {

    .trasation-list-add-button{
            font-size: 22px;
        }
}

</style>